import React from "react";

function PensilIcon({ Strock = "#4072C8" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.96647 2.61043L12.4665 5.11043M8.29981 14.2771H14.9665M1.63314 10.9438L0.799805 14.2771L4.13314 13.4438L13.7881 3.78876C14.1006 3.47621 14.2761 3.05237 14.2761 2.61043C14.2761 2.16849 14.1006 1.74464 13.7881 1.43209L13.6448 1.28876C13.3323 0.976307 12.9084 0.800781 12.4665 0.800781C12.0245 0.800781 11.6007 0.976307 11.2881 1.28876L1.63314 10.9438Z"
        stroke={Strock}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PensilIcon;
